import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label"]
  static values = {
    seconds: Number,
    readyText: String,
    template: String
  }

  connect() {
    this.remaining = this.secondsValue
    if (this.remaining > 0) {
      this.element.disabled = true
      this.updateLabel()
      this.timer = setInterval(() => this.tick(), 1000)
    }
  }

  disconnect() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  tick() {
    this.remaining--
    if (this.remaining <= 0) {
      this.finish()
    } else {
      this.updateLabel()
    }
  }

  updateLabel() {
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = this.templateValue.replace("{seconds}", this.remaining)
    }
  }

  finish() {
    clearInterval(this.timer)
    this.timer = null
    this.element.disabled = false
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = this.readyTextValue
    }
  }
}
